import styled from "styled-components";
import { Box, TableBody, TableCell, TableContainer, TableHead, CircularProgress } from "@mui/material";

export const ScrollableTableContainer = styled(TableContainer)`
  overflow-x: auto;
  max-height: 350px;
  max-width: 100%;

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px; 
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;


export const ScrollableFooter = styled(Box)(({ fontSize, lineHeight, fontWeight, textAlign, padding }) => ({
    fontSize: fontSize || '14px',
    lineHeight: lineHeight || '19px',
    fontWeight: fontWeight || 'normal',
    textAlign: textAlign || 'left',
    padding: padding || '8.5px 20px 0px 20px'
}));

export const FooterText = styled("span")(({ isClickable, color }) => ({
    color: color || '#707070',
    fontWeight: isClickable ? 'bold' : 'normal',
    textDecoration: isClickable ? 'underline' : 'none',
    cursor: isClickable ? 'pointer' : 'default'
}));

export const TableCircularProgress = styled(CircularProgress)(() => ({
    position: 'absolute',
    top: '50%',
    left: '50%%',
    right: '50%'
}));

export const TableRow = styled(TableCell)(() => ({
    '&.MuiTableCell-root': {
        overflowWrap: "break-word",
        padding: '11px',
    },
}));

export const SiteHeadDiv = styled.div`
  padding-top: 4px;
`;

export const SiteHeadSpan = styled.span`
  padding-top: 4px;
  visibility: ${({ isHide }) => (isHide ? "hidden" : "visible")};
`;

export const SiteHeadStyled = styled.div`
  padding-left: 4px;
`;